import { AlpineComponent } from '@alpinejs/csp';
import Lottie from 'lottie-web';
import Rellax from 'rellax';

const Christmascard = (): AlpineComponent => ({
  index: 0,
  heroes: ['ayla', 'eddy', 'vic'],
  animations: [],
  init() {
    this.initHeroesAnimation();
    this.initStarAnimation();
    this.loadParticles();

    new Rellax('.rellax', { center: true });
  },

  initStarAnimation() {
    Lottie.loadAnimation({
      container: this.$refs.animation,
      renderer: 'svg',
      name: 'star',
      autoplay: true,
      loop: false,
      path: '/assets/animations/star.json'
    });

    setTimeout(() => {
      this.$root
        .querySelector('.christmascard__animation-wrapper')
        .classList.add('complete');
    }, 1000);
  },

  initHeroesAnimation() {
    const lang = document.documentElement.lang.toLowerCase();

    (this.heroes as string[]).forEach((hero, index) => {
      const container = this.$refs[hero].querySelector('.christmascard__hero');

      const animation = Lottie.loadAnimation({
        container,
        renderer: 'svg',
        name: hero,
        autoplay: false,
        loop: false,
        path: `/assets/animations/heroes/${hero}-${lang}.json`
      });

      animation.addEventListener('complete', () => this.handleComplete(index));

      this.animations.push(animation);
    });
  },

  handleIntersect() {
    this.playAnimation(0);
  },

  handleComplete(index: number) {
    const animation = this.animations[index];
    const hero = this.heroes[index];
    animation.goToAndStop(0);

    this.$refs[hero].classList.remove('active');
    this.playAnimation(index === this.heroes.length - 1 ? 0 : index + 1);
  },

  playAnimation(index: number) {
    const animation = this.animations[index];
    const hero = this.heroes[index];

    if (animation) {
      this.$refs[hero].classList.add('active');
      animation.play();
    }
  },
  async loadParticles() {
    const { default: generateParticles } = await import(
      '../../javascripts/helpers/particles'
    );

    (
      document.getElementById('particles') as HTMLDivElement
    ).style.height = `${document.body.clientHeight}px`;

    generateParticles('particles');
  }
});

export default Christmascard;
